import baseApplicationItem from './baseApplicationItem'
import {merge} from 'lodash'

var module = {
  endpoint: 'color',
  getNew: {
    deleted: false,
    name: null,
    catalogs: []
  },
  tableInfo: {
    tableFields: [
      {
        name: '__component:badge-deleted-column',
        title: '',
        dataClass: 'text-center'
      },
      {
        name: '__checkbox',
        title: '',
        class: 'primary'
      },
      {
        name: 'id',
        title: 'id',
        sortField: 'id'
      },
      {
        name: 'name',
        title: 'nome',
        sortField: 'name'
      },
      {
        name: 'description',
        title: 'descrizione',
        sortField: 'description'
      },
      {
        name: '__component:actions-column',
        title: '',
        dataClass: 'text-center'
      }
    ],
    sortFunctions: {
    }
  },
}

export default merge(module, baseApplicationItem)



// WEBPACK FOOTER //
// ./src/application/colors.js